export const removeUndefined = <T extends Record<string, any>>(obj: T): T => {
  const result = { ...obj };
  
  const cleanObject = (obj: any): any => {
    if (obj === null || obj === undefined) {
      return undefined;
    }
    
    // Preserve Date objects
    if (obj instanceof Date) {
      return obj;
    }
    // Preserve Firestore Timestamp objects (duck typing)
    if (
      typeof obj === 'object' &&
      obj !== null &&
      typeof obj.toDate === 'function' &&
      typeof obj.seconds === 'number'
    ) {
      return obj;
    }
    
    if (Array.isArray(obj)) {
      return obj.map(cleanObject).filter(item => item !== undefined);
    }
    
    if (typeof obj === 'object') {
      const cleaned: any = {};
      Object.keys(obj).forEach(key => {
        const cleanedValue = cleanObject(obj[key]);
        if (cleanedValue !== undefined) {
          cleaned[key] = cleanedValue;
        }
      });
      return Object.keys(cleaned).length > 0 ? cleaned : undefined;
    }
    
    return obj;
  };
  
  return cleanObject(result) as T;
}; 